import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AccessToken, SystemConfigurationItem } from 'common-models';
import { Configuration } from 'src/Configuration';

export const systemConfigApiSlice = createApi({
  reducerPath: 'systemConfigApi',
  tagTypes: ['systemConfig'],
  baseQuery: fetchBaseQuery({
    baseUrl: Configuration.ApiUrl,
    prepareHeaders(headers) {
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Get all system configurations
    getAllSystemConfigurations: builder.query<Record<string, SystemConfigurationItem>, AccessToken>({
      query: (accessToken) => ({
        url: '/admin/systemconfig',
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      // providesTags: [{ type: 'systemConfig', id: 'all' }],
    }),

    // Get a single configuration by key
    getSystemConfiguration: builder.query<SystemConfigurationItem, { key: string; accessToken: AccessToken }>({
      query: ({ key, accessToken }) => ({
        url: `/admin/systemconfig/${key}`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      // providesTags: (result, error, { key }) => [{ type: 'systemConfig', id: key }],
    }),

    // Set a single configuration
    setSystemConfiguration: builder.mutation<any, { key: string; config: SystemConfigurationItem; accessToken: AccessToken }>({
      query: ({ key, config, accessToken }) => ({
        url: `/admin/systemconfig/${key}`,
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: config,
      }),
      invalidatesTags: (result, error, { key }) => [
        { type: 'systemConfig', id: key },
        { type: 'systemConfig', id: 'all' },
      ],
    }),

    // Set multiple configurations
    setSystemConfigurations: builder.mutation<
      any,
      { configs: Record<string, SystemConfigurationItem>; accessToken: AccessToken }
    >({
      query: ({ configs, accessToken }) => ({
        url: '/admin/systemconfig',
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: configs,
      }),
      invalidatesTags: [{ type: 'systemConfig', id: 'all' }],
    }),

    // Delete a configuration
    deleteSystemConfiguration: builder.mutation<any, { key: string; accessToken: AccessToken }>({
      query: ({ key, accessToken }) => ({
        url: `/admin/systemconfig/${key}`,
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      invalidatesTags: (result, error, { key }) => [
        { type: 'systemConfig', id: key },
        { type: 'systemConfig', id: 'all' },
      ],
    }),
  }),
});

export const {
  useGetAllSystemConfigurationsQuery,
  useGetSystemConfigurationQuery,
  useSetSystemConfigurationMutation,
  useSetSystemConfigurationsMutation,
  useDeleteSystemConfigurationMutation,
} = systemConfigApiSlice;
